export const CUSTOM_BUTTONS = {
  CLEAR: '{clear}',
  CLOSE: '{close}',
  TAB: '{custom_tab}',
};

export const CUSTOM_DISPLAY = {
  [`${CUSTOM_BUTTONS.CLEAR}`]: 'clear',
  [`${CUSTOM_BUTTONS.CLOSE}`]: 'close',
  [`${CUSTOM_BUTTONS.TAB}`]: 'tab',
  '{enter}': 'enter',
  '{bksp}': 'del',
};

export const DEFAULT_KEYBOARD_LAYOUT = {
  default: [
    '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
    `${CUSTOM_BUTTONS.TAB} q w e r t y u i o p [ ] \\`,
    "{lock} a s d f g h j k l ; ' {enter}",
    '{shift} z x c v b n m , . / {shift}',
    `${CUSTOM_BUTTONS.CLOSE} {space} ${CUSTOM_BUTTONS.CLEAR}`,
  ],
  shift: [
    '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
    `${CUSTOM_BUTTONS.TAB} Q W E R T Y U I O P { } |`,
    '{lock} A S D F G H J K L : " {enter}',
    '{shift} Z X C V B N M < > ? {shift}',
    `${CUSTOM_BUTTONS.CLOSE} {space} ${CUSTOM_BUTTONS.CLEAR}`,
  ],
};

export const NUMERIC_KEYBOARD_LAYOUT = {
  default: [
    '1 2 3 -',
    `4 5 6 ${CUSTOM_BUTTONS.TAB}`,
    '7 8 9 {bksp}',
    `${CUSTOM_BUTTONS.CLOSE} , 0 . ${CUSTOM_BUTTONS.CLEAR} {enter}`,
  ],
};

export const LAYOUT_TYPES = {
  DEFAULT: 'default',
  NUMERIC: 'numeric',
};



// WEBPACK FOOTER //
// ./src/common/Components/Keyboard/constants/index.js